import * as React from "react";
import { forwardRef } from "react";
const SvgDownloaded = (props, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.26313 12.4729L10.0033 16.2192L10.0033 3L12.4967 3L12.4967 16.2192L16.2369 12.4729L18 14.2389L11.25 21L4.5 14.2389L6.26313 12.4729Z", fill: "currentcolor" }));
const ForwardRef = forwardRef(SvgDownloaded);
export default ForwardRef;
